import React, { useRef, useEffect, useState } from 'react';
import styled from 'styled-components';
import Container from '../atoms/Container';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import _uniqueId from 'lodash/uniqueId';
import PropTypes from 'prop-types';

gsap.registerPlugin( ScrollTrigger );

const Holder = styled.div`
  background-color: ${props => props.colour === 'White' ? props.theme.colours.white : props.theme.colours.grey};
  padding: 2rem 0;
  @media( ${props => props.theme.breakpoints.md} ) {
    padding: 4rem 0;
  }
`;

const Inner = styled.div`
  display: grid;
  align-items: start;
  grid-template-columns: 1fr;
  grid-row-gap: 3rem;
  grid-column-gap: 2rem;
  @media( ${props => props.theme.breakpoints.md} ) {
    grid-template-columns: 1fr 1fr;
  }
  @media( ${props => props.theme.breakpoints.lg} ) {
    grid-template-columns: repeat(12, 1fr);
    grid-column-gap: 6rem;
  }
`;

function TwoColumn( { children, colour } ) {
  const [ id, setId ] = useState( null );
  const holder = useRef( null );
  const tl = useRef( null );

  useEffect(() => {
    setId( _uniqueId( 'two-col-' ) );
  }, []);

  useEffect( () => {
    if ( !tl.current && id ) {

      tl.current = ScrollTrigger.matchMedia( {
        // desktop
        '(min-width: 576px)': function () {
          gsap.timeline( {
            scrollTrigger: {
              trigger: holder.current,
              start: 'top 75%',
              end: 'top 25%',
              scrub: true,
            }
          } )
          .from( `#${id} .column:first-child`, {
            x: -100,
            y: 50,
            autoAlpha: 0,
            duration: 1,
          } )
          .from( `#${id} .column:last-child`, {
            x: 100,
            y: 50,
            autoAlpha: 0,
            duration: 1,
          }, 0 );

        }
      } );
    }
  }, [ id ] );

  return (
    <Holder ref={holder} colour={colour}>
      <Container uniqueId={id}>
        <Inner>{children}</Inner>
      </Container>
    </Holder>
  )
}

TwoColumn.propTypes = {
  colour: PropTypes.string
};

TwoColumn.defaultProps = {
  colour: 'Grey'
};

export default TwoColumn;
